export default {
  title: {
    id: 'address_book_delete_modal_title',
    defaultMessage: 'Delete address',
  },
  body: {
    id: 'address_book_delete_modal_body',
    defaultMessage:
      'Do you really want to delete this address? All your orders will be returned elsewhere.',
  },
  confirmation: {
    id: 'address_book_delete_modal_confirmation',
    defaultMessage: 'Delete this address',
  },
  cancel: {
    id: 'address_book_delete_modal_cancel',
    defaultMessage: 'Cancel',
  },
  errorTitle: {
    id: 'address_book_delete_error_title',
    defaultMessage: 'Oops, something went wrong.',
  },
}
